/* mossriver-ga4-custom-events-v2
 * Standard page views and commerce events stay owned by Shopify's Google app.
 * This bridge only makes custom experiment events deliverable to GA4.
 */
(function () {
  'use strict';
  if (window.__mossriverGa4CustomEventsV2) return;
  window.__mossriverGa4CustomEventsV2 = true;
  window.dataLayer = window.dataLayer || [];
  var active = false;

  // 2026-10-30 INTERNAL-TRAFFIC MARKER.
  // Visiting any page with ?mr_internal=1 stores a long-lived flag (localStorage
  // + 2-year cookie). While set, every gtag event/config (ours AND Shopify's, since
  // they share window.gtag) carries traffic_type=internal (GA4's built-in internal
  // traffic parameter) and mr_internal=1. ?mr_internal=0 clears it.
  var INTERNAL = (function () {
    var on = false;
    try {
      var mark = new URLSearchParams(location.search).get('mr_internal');
      if (mark === '1') {
        try { localStorage.setItem('mr_internal', '1'); } catch (e1) {}
        try { document.cookie = 'mr_internal=1; max-age=63072000; path=/; SameSite=Lax'; } catch (e2) {}
      } else if (mark === '0') {
        try { localStorage.removeItem('mr_internal'); } catch (e3) {}
        try { document.cookie = 'mr_internal=; max-age=0; path=/; SameSite=Lax'; } catch (e4) {}
        return false;
      }
      try { if (localStorage.getItem('mr_internal') === '1') on = true; } catch (e5) {}
      if (!on && /(?:^|; )mr_internal=1(?:;|$)/.test(document.cookie)) on = true;
    } catch (e) {}
    return on;
  })();
  var INTERNAL_PARAMS = {traffic_type: 'internal', mr_internal: '1'};
  window.__mossriverInternalTraffic = INTERNAL;
  function pushArgs() { window.dataLayer.push(arguments); }

  // 2026-10-29: live article CTAs use mossriver_2026_order_landing (also seo48h/v4_discovery).
  // Map them onto the SEO experiment so namespaced events enter the GA4 catalog.
  var ARTICLE_PDP_CAMPAIGNS = {
    'exp_20260808_article_pdp': 'mossriver-exp-20260808-article-pdp',
    'mossriver_2026_order_landing': 'mossriver-exp-20260808-article-pdp',
    'mossriver_2026_seo48h': 'mossriver-exp-20260808-article-pdp',
    'mossriver_2026_v4_discovery': 'mossriver-exp-20260808-article-pdp'
  };
  function isArticlePdpCampaign(campaign) {
    return !!(campaign && ARTICLE_PDP_CAMPAIGNS[campaign]);
  }
  function articlePdpExperimentId(campaign) {
    return ARTICLE_PDP_CAMPAIGNS[campaign] || '';
  }
  function canonicalArticlePdpCampaign(campaign) {
    return isArticlePdpCampaign(campaign) ? 'exp_20260808_article_pdp' : campaign;
  }

  function measurementLedger() {
    var ledger = [];
    try { ledger = JSON.parse(sessionStorage.getItem('mossriver_measurement_ledger') || '[]'); } catch (e) {}
    return Array.isArray(ledger) ? ledger : [];
  }

  function recordMeasurementEvent(name, params) {
    var a = params || {};
    var ledger = measurementLedger();
    ledger.push({
      sequence: ledger.length + 1,
      event_name: name,
      measurement_run_id: a.moss_measurement_run_id || '',
      experiment_id: a.moss_experiment_id || '',
      campaign: a.moss_campaign || '',
      event_id: a.moss_event_id || '',
      path: location.pathname,
      at: new Date().toISOString()
    });
    try { sessionStorage.setItem('mossriver_measurement_ledger', JSON.stringify(ledger)); } catch (e) {}
  }

  function renderMeasurementReceipt() {
    var q = new URLSearchParams(location.search);
    if (q.get('moss_measurement_receipt') !== '1') return;
    var runId = q.get('moss_measurement_run_id') || '';
    var events = measurementLedger().filter(function (item) { return !runId || item.measurement_run_id === runId; });
    var counts = {};
    events.forEach(function (item) { counts[item.event_name] = (counts[item.event_name] || 0) + 1; });
    var payload = {schema: 'mossriver.browser-measurement-receipt/v1', measurement_run_id: runId, page_path: location.pathname, event_counts: counts, events: events};
    var pre = document.getElementById('mossriver-measurement-receipt');
    if (!pre) { pre = document.createElement('pre'); pre.id = 'mossriver-measurement-receipt'; pre.setAttribute('data-mossriver-receipt', 'v1'); pre.style.cssText = 'white-space:pre-wrap;background:#fff;color:#111;padding:16px;margin:16px;font:12px monospace;position:relative;z-index:2147483647;'; document.body.appendChild(pre); }
    pre.textContent = JSON.stringify(payload, null, 2);
  }

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return true;
    var decision;
    if (typeof privacy.analyticsProcessingAllowed === 'function') decision = privacy.analyticsProcessingAllowed();
    else if (typeof privacy.userCanBeTracked === 'function') decision = privacy.userCanBeTracked();
    // The consent API can return undefined while it is still loading. Only an
    // explicit false blocks, keeping parity with the storefront GA tag.
    return decision !== false;
  }

  var upstreamGtag = window.gtag;
  var articleClickKeys = {};
  var nativeViewItemSeen = false;
  function normalizeArticleClick(params) {
    var a = Object.assign({}, params || {});
    var context = typeof attribution === 'function' ? attribution() : {};
    a.moss_measurement_run_id = a.moss_measurement_run_id || context.run_id || '';
    a.moss_experiment_id = a.moss_experiment_id || a.funnel_id || articlePdpExperimentId(a.moss_campaign || a.campaign || (context && context.campaign) || '');
    a.moss_campaign = a.moss_campaign || a.campaign || context.campaign || '';
    a.moss_source = a.moss_source || context.source || 'unknown';
    a.destination_path = a.destination_path || location.pathname;
    a.moss_event_id = a.moss_event_id || (a.moss_measurement_run_id || 'live') + ':article_pdp_click:' + Date.now();
    return a;
  }
  function recordArticleClick(params) {
    var a = normalizeArticleClick(params);
    var context = typeof attribution === 'function' ? attribution() : {};
    var key = [a.moss_measurement_run_id || context.run_id || '', a.destination_path || location.pathname, a.campaign || context.campaign || ''].join('|');
    if (articleClickKeys[key]) return false;
    articleClickKeys[key] = true;
    recordMeasurementEvent('article_pdp_click', a);
    return true;
  }
  function sendArticleClickBeacon(params) {
    // Enriched collect beacon/fetch — used when upstream gtag is missing OR
    // when unload may kill the library transport before flush (article CTA).
    try {
      var cookie = document.cookie.match(/(?:^|; )_ga=GA\d+\.\d+\.(\d+\.\d+)/);
      var clientId = cookie ? cookie[1] : (window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()));
      var sid = '';
      try {
        var sidCookie = document.cookie.match(/(?:^|; )_ga_8VWWZKPJQ7=([^;]*)/);
        if (sidCookie) {
          var sidParts = decodeURIComponent(sidCookie[1]).split('.');
          if (sidParts.length >= 3) sid = String(sidParts[2]).replace(/^s/, '').split('$')[0];
        }
      } catch (e2) {}
      var gcs = '';
      try {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
          gcs = privacy.analyticsProcessingAllowed() !== false ? 'G111' : 'G100';
        }
      } catch (e3) {}
      var body = new URLSearchParams();
      body.set('en', 'article_pdp_click');
      if (INTERNAL) { body.set('ep.traffic_type', 'internal'); body.set('ep.mr_internal', '1'); }
      Object.keys(params || {}).forEach(function (key) {
        if (key === 'event_callback' || key === 'event_timeout' || params[key] === undefined || params[key] === '') return;
        body.set('ep.' + key, String(params[key]));
      });
      var qs = 'v=2&tid=G-8VWWZKPJQ7&cid=' + encodeURIComponent(clientId) + '&dl=' + encodeURIComponent(location.href);
      if (sid) qs += '&sid=' + encodeURIComponent(sid);
      if (gcs) qs += '&gcs=' + encodeURIComponent(gcs);
      var endpoint = 'https://www.google-analytics.com/g/collect?' + qs;
      if (navigator.sendBeacon && navigator.sendBeacon(endpoint, body)) return true;
      if (window.fetch) { window.fetch(endpoint, {method: 'POST', body: body, keepalive: true, mode: 'no-cors'}); return true; }
    } catch (e) {}
    return false;
  }
  function sendArticleClickToUpstream(params) {
    // Prefer upstream gtag library transport (same shape as landed moss_map).
    // Always also queue enriched beacon on unload-sensitive article clicks —
    // upstream "success" alone was observed with zero g/collect (2026-10-29).
    var delivered = false;
    try {
      if (typeof upstreamGtag === 'function' && upstreamGtag !== bridgeGtag) {
        upstreamGtag.call(window, 'event', 'article_pdp_click', params);
        delivered = true;
      } else if (typeof upstreamGtag !== 'function' || upstreamGtag === bridgeGtag) {
        window.dataLayer.push(['event', 'article_pdp_click', params]);
      }
    } catch (e) {}
    var beaconed = false;
    try { beaconed = sendArticleClickBeacon(params); } catch (e2) {}
    return delivered || beaconed;
  }
  function bridgeGtag() {
    if (INTERNAL && (arguments[0] === 'event' || arguments[0] === 'config') && arguments.length >= 2) {
      var internalArgs = Array.prototype.slice.call(arguments);
      internalArgs[2] = Object.assign({}, internalArgs[2] || {}, INTERNAL_PARAMS);
      return bridgeGtagInner.apply(window, internalArgs);
    }
    return bridgeGtagInner.apply(window, arguments);
  }
  function bridgeGtagInner() {
    if (arguments[0] === 'event' && !active) return;
    if (arguments[0] === 'event' && arguments[1] === 'view_item') nativeViewItemSeen = true;
    if (arguments[0] === 'event' && arguments[1] === 'article_pdp_click' && arguments[2]) {
      arguments[2] = normalizeArticleClick(arguments[2]);
      if (!recordArticleClick(arguments[2])) return;
      // Prefer upstream gtag (inside sendArticleClickToUpstream). Enriched
      // sendBeacon is last-resort only when upstream is unavailable.
      sendArticleClickToUpstream(arguments[2]);
      return;
    }
    if (typeof upstreamGtag === 'function') return upstreamGtag.apply(window, arguments);
    pushArgs.apply(window, arguments);
  }
  // Shopify/Google app code can replace window.gtag after this asset loads.
  // Keep the bridge as the stable public function while forwarding to the
  // latest implementation, so ledger and GA4 delivery cannot diverge merely
  // because of script-load order.
  try {
    Object.defineProperty(window, 'gtag', {
      configurable: true,
      get: function () { return bridgeGtag; },
      set: function (next) { if (next !== bridgeGtag) upstreamGtag = next; }
    });
  } catch (e) {
    window.gtag = bridgeGtag;
  }
  if (INTERNAL) { try { window.gtag('set', INTERNAL_PARAMS); } catch (e) {} }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    if (!/^\/blogs\/articles\//.test(location.pathname)) return;
    var link = event.target.closest('a[href*="utm_campaign="],a[href*="moss_campaign="]');
    if (!link) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var url = new URL(link.href, window.location.origin);
    var campaign = url.searchParams.get('moss_campaign') || url.searchParams.get('utm_campaign') || '';
    var runId = url.searchParams.get('moss_measurement_run_id') || url.searchParams.get('measurement_run_id') || '';
    // Hold navigation for known article→PDP campaigns even without a
    // measurement run id — organic CTAs (order_landing) must still emit
    // article_pdp_click before unload.
    if (!isArticlePdpCampaign(campaign)) return;
    // Only product/collection destinations count as article→PDP.
    if (!/^\/(products|collections)\//.test(url.pathname || '')) return;
    // Do NOT require `active` here. Consent/start can lag past first CTA
    // click; gating on active previously dropped article_pdp_click while
    // the browser navigated away (2026-10-29 browse proof).
    if (!active) {
      try { start(); } catch (e) {}
    }
    if (!analyticsAllowed()) return;
    var source = url.searchParams.get('moss_source') || url.searchParams.get('utm_source') || 'unknown';
    event.preventDefault();
    var navigated = false;
    function continueNavigation() {
      if (navigated) return;
      navigated = true;
      window.location.assign(url.href);
    }
    var effectiveRun = runId || 'live';
    var clickParams = normalizeArticleClick({
      moss_measurement_run_id: effectiveRun,
      moss_experiment_id: articlePdpExperimentId(campaign),
      moss_campaign: campaign,
      campaign: campaign,
      destination_path: url.pathname,
      moss_event_id: effectiveRun + ':article_pdp_click:' + Date.now(),
      moss_source: source,
      event_callback: continueNavigation,
      event_timeout: 1500
    });
    // Deliver via upstream path directly so a still-inactive bridgeGtag
    // active-gate cannot swallow the hit.
    try { recordArticleClick(clickParams); } catch (e) {}
    try { sendArticleClickToUpstream(clickParams); } catch (e) {}
    // Navigation unloads the document immediately. Prefer GA's callback, with
    // a bounded fallback so a blocked analytics endpoint cannot strand users.
    window.setTimeout(continueNavigation, 1800);
  }, true);

  function start() {
    if (active || !analyticsAllowed()) return;
    active = true;
    if (!document.querySelector('script[data-mossriver-ga4-custom-events]')) {
      var tag = document.createElement('script');
      tag.async = true;
      tag.src = 'https://www.googletagmanager.com/gtag/js?id=G-8VWWZKPJQ7';
      tag.setAttribute('data-mossriver-ga4-custom-events', 'v2');
      document.head.appendChild(tag);
    }
    window.gtag('js', new Date());
    window.gtag('config', 'G-8VWWZKPJQ7', {send_page_view: false});
    propagateAttributionLinks();
    if (/^\/blogs\/articles\//.test(location.pathname)) syncArticleCampaignCartAttribute();
    if (!window.__mossriverAttributionObserver) {
      window.__mossriverAttributionObserver = new MutationObserver(function () { propagateAttributionLinks(); });
      window.__mossriverAttributionObserver.observe(document.documentElement, {childList: true, subtree: true});
    }
  }

  function loadPrivacyThenStart() {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{name: 'consent-tracking-api', version: '0.1'}],
        function () { start(); }
      );
      // Article templates may expose loadFeatures without ever invoking the
      // callback. Do not let that stall the measurement bridge indefinitely;
      // start() still applies the consent checks and is idempotent.
      setTimeout(start, 1500);
    } else {
      start();
    }
  }

  document.addEventListener('visitorConsentCollected', start, false);
  document.addEventListener('trackingConsentAccepted', start, false);
    loadPrivacyThenStart();

  function attribution() {
    var q = new URLSearchParams(location.search);
    var saved = {};
    try { saved = JSON.parse(sessionStorage.getItem('mossriver_funnel_context') || '{}'); } catch (e) {}
    var source = q.get('moss_source') || q.get('utm_source') || saved.source || 'direct';
    var campaign = q.get('moss_campaign') || q.get('utm_campaign') || saved.campaign || '';
    var content = q.get('moss_content') || q.get('utm_content') || saved.content || '';
    var runId = q.get('moss_measurement_run_id') || q.get('measurement_run_id') || saved.run_id || '';
    if (q.get('moss_campaign') || q.get('utm_campaign')) {
      try { sessionStorage.setItem('mossriver_funnel_context', JSON.stringify({source: source, campaign: campaign, content: content, run_id: runId})); } catch (e) {}
    }
    return {
      source: source,
      campaign: campaign,
      content: content,
      run_id: runId
    };
  }

  var mossCampaignAttrInflight = false;
  function syncArticleCampaignCartAttribute() {
    var a = attribution();
    if (!a || !isArticlePdpCampaign(a.campaign)) return;
    if (mossCampaignAttrInflight) return;
    mossCampaignAttrInflight = true;
    fetch('/cart.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}, keepalive: true})
      .then(function (response) { return response && response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart) { mossCampaignAttrInflight = false; return; }
        var attrs = {};
        var existing = cart.attributes;
        if (existing && typeof existing === 'object') {
          Object.keys(existing).forEach(function (key) {
            if (existing[key] != null) attrs[key] = existing[key];
          });
        }
        if (attrs.moss_campaign === 'exp_20260808_article_pdp'
            && attrs.moss_experiment_id === 'mossriver-exp-20260808-article-pdp') {
          mossCampaignAttrInflight = false;
          return;
        }
        // Canonical campaign so thank-you purchase readback maps onto
        // mossriver_exp_article_pdp_* even when surface CTA was order_landing.
        attrs.moss_campaign = 'exp_20260808_article_pdp';
        attrs.moss_experiment_id = articlePdpExperimentId(a.campaign);
        attrs.moss_surface_campaign = a.campaign || '';
        if (a.run_id) attrs.moss_measurement_run_id = a.run_id;
        if (a.source) attrs.moss_source = a.source;
        if (a.content) attrs.moss_content = a.content;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          keepalive: true,
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({attributes: attrs})
        }).then(function () { mossCampaignAttrInflight = false; }, function () { mossCampaignAttrInflight = false; });
      })
      .catch(function () { mossCampaignAttrInflight = false; });
  }

  function propagateAttributionLinks() {
    var a = attribution();
    if (!a.campaign) return;
    // Organic article-pdp CTAs often have no measurement run id; still stamp
    // moss_campaign so PDP commerce rename can fire.
    if (!a.run_id && !isArticlePdpCampaign(a.campaign)) return;
    document.querySelectorAll('a[href]').forEach(function (link) {
      var raw = link.getAttribute('href') || '';
      if (!raw || raw.charAt(0) === '#' || raw.indexOf('javascript:') === 0) return;
      var url;
      try { url = new URL(raw, window.location.origin); } catch (e) { return; }
      if (url.origin !== window.location.origin) return;
      if (!/^\/(?:products|collections|cart|checkout)(?:\/|$)/.test(url.pathname)) return;
      url.searchParams.set('moss_source', a.source);
      url.searchParams.set('moss_campaign', a.campaign);
      if (a.content) url.searchParams.set('moss_content', a.content);
      if (a.run_id) url.searchParams.set('moss_measurement_run_id', a.run_id);
      link.setAttribute('href', url.pathname + (url.search ? url.search : '') + (url.hash || ''));
    });
  }

  function emit(name, params) {
    if (!active || !analyticsAllowed()) return;
    recordMeasurementEvent(name, params || {});
    // Plain gtag library transport (match landed moss_map_incentive_opt_in).
    // Do not force transport_type:beacon — wire table showed beacon-tagged
    // custom events dropped while plain gtag custom events landed.
    window.gtag('event', name, Object.assign({}, params || {}));
  }

  var emittedEventKeys = {};
  function emitCommerceEvent(name, params, campaign, dedupeKey) {
    var key = dedupeKey || name;
    if (emittedEventKeys[key]) return false;
    emittedEventKeys[key] = true;
    var a = attribution();
    var effectiveCampaign = campaign || a.campaign || '';
    var eventParams = Object.assign({
      moss_measurement_run_id: a.run_id,
      moss_experiment_id: articlePdpExperimentId(effectiveCampaign) || undefined,
      moss_event_id: (a.run_id || 'live') + ':' + name + ':' + Date.now() + ':' + Math.random().toString(36).slice(2, 8)
    }, params || {});
    // Shopify's Google channel already owns the standard view_item event.
    // Record it for the same-session receipt, but do not send a second
    // standard hit from this bridge.
    if (name === 'view_item') {
      recordMeasurementEvent(name, eventParams);
      if (!nativeViewItemSeen) window.gtag('event', name, Object.assign({}, eventParams));
    }
    else emit(name, eventParams);
    var experimentEvents = {
      'exp_20260808_article_pdp': {
        'view_item': 'mossriver_exp_article_pdp_view_item',
        'add_to_cart': 'mossriver_exp_article_pdp_add_to_cart',
        'begin_checkout': 'mossriver_exp_article_pdp_begin_checkout',
        'purchase': 'mossriver_exp_article_pdp_purchase'
      }
    };
    var mapped = experimentEvents[canonicalArticlePdpCampaign(effectiveCampaign)]
      && experimentEvents[canonicalArticlePdpCampaign(effectiveCampaign)][name];
    if (mapped) emit(mapped, eventParams);
    return true;
  }

  function emitAddToCartOnce(form, meta, product, campaign) {
    if (!form || form.dataset.mossriverAddTracked === '1') return;
    form.dataset.mossriverAddTracked = '1';
    var a = attribution();
    emitCommerceEvent('add_to_cart', {currency: (meta.currency || 'USD'), moss_source: a.source, moss_campaign: a.campaign, items: [{item_id: String(product.id), item_name: product.handle}]}, campaign, 'add_to_cart:' + String(product.id));
    setTimeout(function() { delete form.dataset.mossriverAddTracked; }, 1500);
  }

  function installCommerceReadback() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var product = meta && meta.product;
    if (!product || !product.id || window.__mossriverViewItemV2) return false;
    window.__mossriverViewItemV2 = true;
    var selected = product.variants && product.variants[0];
    var a = attribution();
    var viewItemPayload = {
      currency: (meta.currency || 'USD'),
      value: selected ? Number(selected.price || 0) / 100 : undefined,
      items: [{item_id: String(product.id), item_name: selected ? selected.name : product.handle, item_variant: selected ? String(selected.id) : undefined}],
      moss_source: a.source, moss_campaign: a.campaign, moss_content: a.content
    };
    // Shopify's native analytics script can load after the theme asset. Delay
    // only this first event so the namespaced experiment event is not lost.
    setTimeout(function() { emitCommerceEvent('view_item', viewItemPayload, a.campaign, 'view_item:' + String(product.id)); }, 2500);
    document.addEventListener('submit', function(event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      emitAddToCartOnce(form, {currency: (meta.currency || 'USD')}, product, a.campaign);
    }, true);
    document.addEventListener('click', function(event) {
      var target = event.target.closest && event.target.closest('button[type="submit"],input[type="submit"]');
      if (!target) return;
      var form = target.form || target.closest('form');
      if (!form || !/\/cart\/add/.test(form.action || '')) return;
      emitAddToCartOnce(form, {currency: (meta.currency || 'USD')}, product, a.campaign);
    }, true);
    document.addEventListener('click', function(event) {
      var link = event.target.closest && event.target.closest('a[href*="/checkout"]');
      if (link) {
        syncArticleCampaignCartAttribute();
        emitCommerceEvent('begin_checkout', {currency: (meta.currency || 'USD'), moss_source: a.source, moss_campaign: a.campaign, items: [{item_id: String(product.id), item_name: product.handle}]}, a.campaign, 'begin_checkout');
      }
    }, true);
    return true;
  }

  function installCommerceWhenReady(attempt) {
    if (installCommerceReadback()) return;
    if (attempt < 60) setTimeout(function() { installCommerceWhenReady(attempt + 1); }, 250);
  }

  function installCheckoutReadback() {
    if (window.__mossriverCheckoutReadbackV2) return;
    window.__mossriverCheckoutReadbackV2 = true;
    var a = attribution();
    function checkoutPayload() {
      return {moss_source: a.source, moss_campaign: a.campaign, moss_content: a.content};
    }
    document.addEventListener('click', function(event) {
      var target = event.target.closest && event.target.closest('a,button');
      if (target && (/\/checkout/.test(target.href || '') || /check\s*out/i.test(target.textContent || ''))) {
        syncArticleCampaignCartAttribute();
        emitCommerceEvent('begin_checkout', checkoutPayload(), a.campaign, 'begin_checkout');
      }
    }, true);
    document.addEventListener('submit', function(event) {
      var form = event.target;
      if (form && /\/checkout/.test(form.action || '')) {
        syncArticleCampaignCartAttribute();
        emitCommerceEvent('begin_checkout', checkoutPayload(), a.campaign, 'begin_checkout');
      }
    }, true);
  }

  function installPurchaseReadback() {
    if (window.__mossriverPurchaseReadbackV2) return;
    window.__mossriverPurchaseReadbackV2 = true;
    function firePurchase(campaign, attrs) {
      try {
        var checkout = (window.Shopify && Shopify.checkout) ? Shopify.checkout : null;
        var value = 0;
        var currency = 'USD';
        var tx = '';
        if (checkout) {
          value = Number(checkout.total_price || checkout.totalPrice || 0);
          if (value > 1000) value = value / 100;
          currency = checkout.currency || currency;
          tx = String(checkout.order_id || checkout.orderId || checkout.token || '');
        }
        var camp = (attrs && attrs.moss_campaign) || campaign || '';
        if (!isArticlePdpCampaign(camp) && camp !== 'exp_20260808_article_pdp') {
          if (!(attrs && attrs.moss_experiment_id === 'mossriver-exp-20260808-article-pdp')) return;
          camp = 'exp_20260808_article_pdp';
        }
        emitCommerceEvent('purchase', {
          currency: currency,
          value: value || 0,
          transaction_id: tx
        }, camp, 'purchase');
      } catch (e) {}
    }
    try {
      var path = location.pathname || '';
      var onThankYou = /thank_you|\/checkouts\/.+\/thank|\/orders\//.test(path)
        || !!(window.Shopify && Shopify.Checkout && Shopify.Checkout.step === 'thank_you');
      if (!onThankYou && !(window.Shopify && Shopify.checkout)) return;
      var a = attribution();
      if (window.fetch) {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            firePurchase(a.campaign, (cart && cart.attributes) || {});
          })
          .catch(function () { firePurchase(a.campaign, {}); });
      } else {
        firePurchase(a.campaign, {});
      }
    } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() { installCommerceWhenReady(0); }, 0);
    setTimeout(installCheckoutReadback, 0);
    setTimeout(installPurchaseReadback, 0);
    setTimeout(renderMeasurementReceipt, 50);
  });
  setTimeout(renderMeasurementReceipt, 2500);
}());
